// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_dompurify_dist_purify_js":"ac49df5c9ba70752d566","vendors-node_modules_canvg_lib_index_es_js":"aa2ae396ca0e65aa0c9a"}[chunkId] + ".js";
};